import React, { useCallback, useContext, useEffect, useState } from "react";
import { Button, Input, Table, Tooltip } from "antd";
import { PlusOutlined, EditOutlined } from "@ant-design/icons";
import moment from "moment";
// import AddCategory from "./AddCategory";
// import EditCategory from "./EditCategory";
import { UserInfo } from "../../../../context";
import axios from "axios";
import AddDiscount from "./AddDiscount";
import EditDiscount from "./EditDiscount";
// import AddProductCategory from "./AddProductCategory";
// import ProductCategoryEdit from "./ProductCategoryEdit";

const MerchantProductDiscount = ({ limit }) => {
  const [productDiscount, setProductDiscount] = useState({
    data: [],
    ready: false,
  });
  const [loading, setLoading] = useState(false);
  const [openDrawer, setOpenDrawer] = useState(false);
  const tableLayout = "";
  const scroll = {};
  const [editDrawer, setEditDrawer] = useState(false);
  const [selectedData, setSelectedData] = useState(null);
  const [search, setSearch] = useState("");
  const { userData } = useContext(UserInfo);

  const columns = [
    {
      title: "Date Created",
      dataIndex: "created_at",
      align: "center",
      render: (date) => (
        // <p style={{ textAlign: "left" }}>
        //   {moment(new Date(date), "YYYY-MM-DD").format("MMMM DD, YYYY")}
        // </p>
        <p style={{ textAlign: "left" }}>
          {moment.utc(new Date(date)).format("MMMM DD, YYYY")}
        </p>
      ),
    },
    {
      title: "Description",
      dataIndex: "description",
      align: "center",
      render: (text, record) => <p style={{ textAlign: "left" }}>{text}</p>,
    },
    {
      title: "Percentage",
      dataIndex: "percentage",
      align: "center",
      render: (text, record) => <p style={{ textAlign: "center" }}>{text}%</p>,
    },
    {
      title: "",
      dataIndex: "",
      align: "center",
      width: 40,
      render: (text) => (
        <p>
          <Tooltip title="Edit">
            <Button
              type="dashed"
              shape="circle"
              onClick={() => {
                setSelectedData(text);
                setEditDrawer(true);
              }}
              icon={<EditOutlined />}
            />
          </Tooltip>
        </p>
      ),
    },
  ];

  const tableProps = {
    bordered: false,
    loading,
    size: "medium",
    // expandable,
    showHeader: true,
    scroll,
    tableLayout,
  };

  const tableColumns = columns.map((item) => ({
    ...item,
    ellipsis: false,
  }));

  const getProductDiscount = useCallback(() => {
    var params = { user_id: userData.data.id };
    axios
      .get("user/merchant/discount-list", { params })
      .then((response) => {
        const data = response.data;
        setProductDiscount({ data, ready: true });
      })
      .catch((error) => {
        console.log("ERROR: ", error);
      });
  }, [userData.data.id]);

  const searchable = productDiscount.data.filter((data) => {
    return data.description.toLowerCase().indexOf(search.toLowerCase()) >= 0;
  });

  useEffect(() => {
    getProductDiscount();
  }, [getProductDiscount]);

  return (
    <>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          marginBottom: 5,
        }}
      >
        <div style={{ flexGrow: 1 }}>
          <Input
            id="search"
            placeholder="Search description"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            style={{
              border: "2px solid #e5e5e5",
              width: window.innerWidth < 576 ? "100%" : 300,
            }}
            size="large"
          />
        </div>
        <Button
          type="primary"
          icon={<PlusOutlined />}
          onClick={() => setOpenDrawer(true)}
          disabled={productDiscount.data.length >= parseInt(limit)}
        >
          Add Discount
        </Button>
      </div>
      <div style={{ overflowX: "auto" }}>
        <Table
          {...tableProps}
          pagination={{
            position: ["bottomCenter"],
          }}
          columns={tableColumns}
          dataSource={searchable.length > 0 ? searchable : []}
          scroll={scroll}
          rowKey={(record) => record.id}
        />
      </div>

      {openDrawer && (
        <AddDiscount
          open={openDrawer}
          close={() => setOpenDrawer(false)}
          setLoading={setLoading}
          getProductDiscount={() => getProductDiscount()}
          limit={limit}
        />
      )}

      {editDrawer && (
        <EditDiscount
          open={editDrawer}
          close={() => setEditDrawer(false)}
          setLoading={setLoading}
          getProductDiscount={() => getProductDiscount()}
          selectedData={selectedData}
        />
      )}
    </>
  );
};

export default MerchantProductDiscount;
